<template>
  <div>
    <Nav v-if="PsjID"/>
    <div class="step-box step-box2" v-else>
      <!-- <img src="https://ef-eztm.oss-cn-beijing.aliyuncs.com/ezt-img/2920/en2.png" width="100%"> -->
      <img :src="en2" width="100%">
    </div>
    <div class="question_box" :style="syStyle">
      <!-- <h3 style="margin-left: 20%;">Remittances account</h3> -->
      <h3 style="margin-left: 20%;">Questionnaire</h3>
      <p class="proTips" :style="proStyle">{{questionnairePro}}</p>
      <div class="quest-box" v-for="(item,index) in quest" :key="index">
      <!-- <div style="padding: 30px 80px; font-size:16px; line-height:30px;">
        <h2 style="font-size:16px;">The foreign currency account is a US dollar account. If the payment is made in US dollars, the receiving currency remains unchanged; If it is paid in euros, it will be converted into US dollars first.</h2>
        <p>Account: China Chamber of International Commerce</p>
        <p>Address:8thFloor,CCOICBuilding,No.2Huapichang Hutong,Xicheng District,Beijing,100035,PR</p>
        <p>Bank Name：Bank of China Head Office</p>
        <p>Bank Address:  1 FUXINGMEN NEI DAJIE, BEIJING 100818,CHINA</p>
        <p>SWIFT:BKCH CN BJ</p>
        <p>Account Number: 7783 5013 8040</p>
        <p style="color:red;">* Remittance, please be sure to indicate</p>
        <p style="color:red;">* Remittance unit name first name must be consistent with the invoice</p>
      </div> -->
			<div class="box-card" v-if="item.answerType==0">
			  <div slot="header" class="clearfix questT">
			    <span>
			      <span style="color:#ED008C;" v-if="item.required">*</span>
			      {{item.QusNum}}.
			      {{item.enQuest}}
			    </span>
			  </div>
			  <el-input
			    :autosize="{ minRows: 4, maxRows: 2}"
			    type="textarea"
			    :name="item.QusID+':'+item.answerOption[0].TssTagID+':'"
			    v-model="otherText['val'+item.QusID+':'+item.answerOption[0].TssTagID+':']"
			    @blur="remarkInput(item.QusID+':'+item.answerOption[0].TssTagID+':')"
			    :data-index="'val'+item.QusID+':'+item.answerOption[0].TssTagID+':'"
			    maxlength="50"
			  ></el-input>
			</div>
			
			<div class="box-card" v-if="item.answerType==1">
			  <div slot="header" class="clearfix questT">
			    <span>
			      <span style="color:#ED008C;" v-if="item.required">*</span>
			      {{item.QusNum}}.
			      {{item.enQuest}}
			    </span>
			  </div>
			  <el-radio-group
			    v-model="answerArr[index]"
			    @change="cacheAnswer"
			    :class="[{'answer-container--firstLevel': ['2'].indexOf(item.QusNum) !== -1 }, 'val'+item.QusID]"
			  >
			    <div
			      :class="{'answer-firstLevel': ['2'].indexOf(item.QusNum) !== -1 }"
			      v-for="(itemO,indexO) in item.answerOption"
			      :key="indexO"
			    >
			      <div
			        style="padding-left: 15px"
			        class="text answer-item"
			        v-if="itemO.answersOption.length<=0"
			      >
			        <el-radio
			          v-if="itemO.ansLeveInputText==false"
			          @change="clearRadioRemark('val'+item.QusID+':'+itemO.TssTagID+':')"
			          :label="item.QusID+':'+itemO.TssTagID+':;'"
			          border
			        >{{itemO.EnTssTagName}}</el-radio>
			        <el-radio
			          v-if="itemO.ansLeveInputText==true"
			          :label="item.QusID+':'+itemO.TssTagID+':'"
			          border
			          @change="clearRadioRemark('val'+item.QusID+':'+itemO.TssTagID+':')"
			        >{{itemO.EnTssTagName}}</el-radio>
			        <el-input
			          :name="item.QusID+':'+itemO.TssTagID+':'"
			          class="radio question-other-input"
			          v-if="itemO.ansLeveInputText==true"
			          v-model="otherText['val'+item.QusID+':'+itemO.TssTagID+':']"
			          @blur="remarkInput(item.QusID+':'+itemO.TssTagID+':')"
			          :data-index="'val'+item.QusID+':'+itemO.TssTagID+':'"
			          :disabled="!(answerArr[index]==item.QusID+':'+itemO.TssTagID+':')"
			          :placeholder="itemO.AnsInputTipText?itemO.AnsInputTipText:'Others, please specify'"
			          maxlength="50"
			          @keyup.native="regFun('remark','val'+item.QusID+':'+itemO.TssTagID+':',otherText['val'+item.QusID+':'+itemO.TssTagID+':'])"
			        ></el-input>
			      </div>
			      <!-- 二级调问 单选-->
			      <div class="text" v-if="itemO.answersOption.length>0">
			        <div
			          class="h3 radio-level-name"
			          @click="setRadioIds(item.QusID+':'+itemO.TssTagID)"
			        >
			          <div v-if="radioIds.indexOf(item.QusID+':'+itemO.TssTagID) === -1">
			            <label role="radio" tabindex="-1" class="el-radio">
			              <span class="el-radio__input">
			                <span class="el-radio__inner"></span>
			              </span>
			              <span class="el-radio__label">{{itemO.EnTssTagName}}</span>
			            </label>
			          </div>
			
			          <div v-if="radioIds.indexOf(item.QusID+':'+itemO.TssTagID) !== -1 ">
			            <label
			              role="radio"
			              tabindex="0"
			              class="el-radio is-checked"
			              aria-checked="true"
			            >
			              <span class="el-radio__input is-checked">
			                <span class="el-radio__inner"></span>
			              </span>
			              <span class="el-radio__label">{{itemO.EnTssTagName}}</span>
			            </label>
			          </div>
			        </div>
			
			        <div
			          style="padding-left:30px"
			          v-for="(itemI,indexI) in itemO.answersOption"
			          :key="indexI"
			        >
			          <div v-if="radioIds.indexOf(item.QusID+':'+itemO.TssTagID) !== -1">
			            <el-radio
			              v-if="itemI.ansLeveInputText==false"
			              @change="clearRadioRemark('val'+item.QusID+':'+itemI.TssTagID+':',itemO.TssTagID)"
			              :label="item.QusID+':'+itemO.TssTagID+';'+itemI.TssTagID+':;'"
			              border
			            >{{itemI.TssTagName}}</el-radio>
			            <el-radio
			              v-if="itemI.ansLeveInputText==true"
			              @change="clearRadioRemark('val'+item.QusID+':'+itemI.TssTagID+':',itemO.TssTagID)"
			              :label="item.QusID+':'+itemO.TssTagID+';'+itemI.TssTagID+':;'"
			              border
			            >{{itemI.TssTagName}}</el-radio>
			            <div
			              class="radio"
			              style="display: inline-block;"
			              v-if="itemI.ansLeveInputText==true"
			            >
			              <el-input
			                class="question-other-input"
			                type="text"
			                maxlength="50"
			                :name="item.QusID+':'+itemI.TssTagID+':'"
			                :data-index="'val'+item.QusID+':'+itemI.TssTagID+':'"
			                v-model="otherText['val'+item.QusID+':'+itemI.TssTagID+':']"
			                @blur="remarkInput('val'+item.QusID+':'+itemI.TssTagID+':')"
			                :disabled="!(answerArr[index]==item.QusID+':'+itemO.TssTagID+';'+itemI.TssTagID+':;')"
			                :placeholder="itemI.AnsInputTipText?itemI.AnsInputTipText:'Others, please specify'"
			                @keyup.native="regFun('remark','val'+item.QusID+':'+itemI.TssTagID+':',otherText['val'+item.QusID+':'+itemI.TssTagID+':'])"
			              ></el-input>
			            </div>
			          </div>
			        </div>
			      </div>
			      <!-- 二级调问 单选 end -->
			    </div>
			  </el-radio-group>
			</div>
			
			<div class="box-card" v-if="item.answerType==2">
			  <div slot="header" class="clearfix questT">
			    <span style="color:#ED008C;" v-if="item.required">*</span>
			    <span>{{item.QusNum}}. {{item.enQuest}}</span>
			  </div>
			  <el-checkbox-group
			    v-model="checkList[index]"
			    @change="cacheAnswer"
			    :class="{'answer-container--firstLevel': ['5'].indexOf(item.QusNum) !== -1 }"
			  >
			    <div
			      :class="{'answer-firstLevel': ['5'].indexOf(item.QusNum) !== -1 }"
			      v-for="(itemO,indexO) in item.answerOption"
			      :key="indexO"
			    >
			      <div
			        style="padding-left: 15px"
			        class="text answer-item"
			        v-if="itemO.answersOption.length<=0"
			      >
			        <el-checkbox
			          v-if="itemO.ansLeveInputText==false"
			          :label="item.QusID+':'+itemO.TssTagID+':;'"
			          :disabled="repelArr[index].join('').indexOf(checkList[index].join('')?checkList[index].join(''):' ')>-1&&checkList[index].join('')!=(item.QusID+':'+itemO.TssTagID+':;')"
			          @change="repelBox(itemO.AnsRepelOthers,index,item)"
			          border
			        >{{itemO.EnTssTagName}}</el-checkbox>
			        <el-checkbox
			          v-if="itemO.ansLeveInputText==true"
			          :disabled="repelArr[index].join('').indexOf(checkList[index].join('')?checkList[index].join(''):' ')>-1&&checkList[index].join('')!=(item.QusID+':'+itemO.TssTagID+':;')"
			          :label="item.QusID+':'+itemO.TssTagID+':'"
			          border
			          @change="clearRemark('val'+item.QusID+':'+itemO.TssTagID+':', itemO.AnsRepelOthers, index, item)"
			        >{{itemO.EnTssTagName}}</el-checkbox>
			        <el-input
			          class="question-other-input"
			          :name="item.QusID+':'+itemO.TssTagID+':'"
			          v-if="itemO.ansLeveInputText==true"
			          v-model="otherText['val'+item.QusID+':'+itemO.TssTagID+':']"
			          @blur="remarkInput(item.QusID+':'+itemO.TssTagID+':')"
			          :data-index="index"
			          :disabled="checkList[index].join('').indexOf(item.QusID+':'+itemO.TssTagID+':')<0"
			          :placeholder="itemO.AnsInputTipText?itemO.AnsInputTipText:'Others, please specify'"
			          maxlength="50"
			          @keyup.native="regFun('remark','val'+item.QusID+':'+itemO.TssTagID+':',otherText['val'+item.QusID+':'+itemO.TssTagID+':'])"
			        ></el-input>
			      </div>
			
			      <!--二级调问多选-->
			      <div class="text item" v-if="itemO.answersOption.length>0">
			        <div class="h3 checkbox-level-name" @click="clickShow(itemO.TssTagID)">
			          <div v-if="titleNum.indexOf(itemO.TssTagID) === -1">
			            <label role="checkbox" class="el-checkbox">
			              <span aria-checked="mixed" class="el-checkbox__input">
			                <span class="el-checkbox__inner"></span>
			              </span>
			              <span class="el-checkbox__label">{{itemO.EnTssTagName}}</span>
			            </label>
			          </div>
			
			          <div v-if="titleNum.indexOf(itemO.TssTagID) !== -1 ">
			            <label role="checkbox" class="el-checkbox is-checked" aria-checked="true">
			              <span aria-checked="mixed" class="el-checkbox__input is-checked">
			                <span class="el-checkbox__inner"></span>
			              </span>
			              <span class="el-checkbox__label">{{itemO.EnTssTagName}}</span>
			            </label>
			          </div>
			        </div>
			        <!--
			          answer-container--firstLevel，
			          answer-firstLevel 为选项两列显示，
			          如需要左右排列的，可传题号替换到‘999’ 数组中
			        -->
			        <div
			          :class="[{'answer-container--firstLevel': ['999'].indexOf(item.QusNum) !== -1 }, 'second-level-container']"
			        >
			          <div
			            :class="{'answer-firstLevel': ['999'].indexOf(item.QusNum) !== -1 }"
			            v-for="(itemI,indexI) in itemO.answersOption"
			            :key="indexI"
			          >
			            <div v-if="titleNum.indexOf(itemO.TssTagID) !== -1">
			              <el-checkbox
			                v-if="itemI.ansLeveInputText==false"
			                @change="setFirstLevelCheckbox(itemO.TssTagID);repelBox(itemI.AnsRepelOthers,index,item)"
			                :label="item.QusID+':'+itemI.TssTagID+':;'"
			                border
			              >{{itemI.TssTagName}}</el-checkbox>
			              <el-checkbox
			                v-if="itemI.ansLeveInputText==true"
			                @change="setFirstLevelCheckbox(itemO.TssTagID);clearRemark('val'+item.QusID+':'+itemI.TssTagID+':', itemI.AnsRepelOthers, index, item)"
			                :label="item.QusID+':'+itemI.TssTagID+':'"
			                border
			              >{{itemI.TssTagName}}</el-checkbox>
			              <div style="display: inline-block;" v-if="itemI.ansLeveInputText==true">
			                <el-input
			                  class="question-other-input"
			                  type="text"
			                  maxlength="50"
			                  :name="item.QusID+':'+itemI.TssTagID+':'"
			                  v-model="otherText['val'+item.QusID+':'+itemI.TssTagID+':']"
			                  @blur="remarkInput(item.QusID+':'+itemI.TssTagID+':')"
			                  :disabled="checkList[index].join('').indexOf(item.QusID+':'+itemI.TssTagID+':')<0"
			                  :placeholder="itemI.AnsInputTipText?itemI.AnsInputTipText:'Others, please specify'"
			                  @keyup.native="regFun('remark','val'+item.QusID+':'+itemI.TssTagID+':',otherText['val'+item.QusID+':'+itemI.TssTagID+':'])"
			                ></el-input>
			              </div>
			            </div>
			          </div>
			        </div>
			      </div>
			      <!-- 二级调问 end -->
			    </div>
			  </el-checkbox-group>
			</div>
			</div>
      <div class="btn-box">
        <div class="question_btn" v-if="!PsjID">
          <el-button class="question_btn" :style="btnAllStyle" type="primary" @click="backQuFest">Back</el-button>
        </div>
        <div class="question_btn"> <!-- v-if="!PsjID" -->
          <el-button class="question_btn" :loading="showBtnLoading" :style="btnAllStyle" @click="submitQuest" type="primary">Next</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api'
import Nav from '../components/Nav'
import utils from '../utils'
import en2 from '../../static/img/en2.png'
export default {
  name: 'Questionnare',
  components: {
    Nav
  },
  data() {
    return {
      en2: en2,
      stepNum: 2,
      PsjID: sessionStorage.getItem('PsjID'),
      ExhID: sessionStorage.getItem('ExhID'),
      showBtnLoading: false,
      stepImg: [],
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      PhotoUrl: '',
	  
      quest: [], // 题目数据
      answer: '', // 提交问题
      answerArr: [],
      otherText: {},
      checkList: [],
      repelArr: [], // 互斥数组
      answerObj: {},
      titleNum: [], // 有二级调问的多选选答案号
      radioIds: [], // 有二级调问的单选答案号
      syStyle: JSON.parse(sessionStorage.getItem('syStyle')) || {},
      otherTips: {},
      questionnairePro: '', // 页面提示语
      proStyle: {} // 提示语样式
    }
  },
  mounted() {
    this.PsjID = sessionStorage.getItem('PsjID')
    var checkList = sessionStorage.getItem('checkList')
    var otherText = sessionStorage.getItem('otherText')
    var answerArr = sessionStorage.getItem('answerArr')
    if (checkList && otherText) {
      this.checkList = JSON.parse(checkList)
      this.otherText = JSON.parse(otherText)
      this.answerArr = JSON.parse(answerArr) || []
    }
    this.load()
    if (sessionStorage.getItem('stepImg')) {
      this.stepImg = JSON.parse(sessionStorage.getItem('stepImg'))
    } else {
      this.stepImg = []
    }
    utils.setThemeColor()
    this.PhotoUrl = this.$route.query.photoImg
    this.getConfigInfo()
  },
  methods: {
    getConfigInfo() {
      var That = this
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'AddAnswer'
      }
      api.getPage(param).then(res => {
        if(res.data.status === 'OK') {
          res.data.promptinfo.forEach(ele => {
            if(ele.name === 'questionnairePro') {
              That.questionnairePro = ele.value
              That.proStyle = ele.styles
            }
          })
        }else{
          That.$alert(res.data.ErrorMsg)
        }
      })
    },
    regFun: function(v, kes, v1) {
      if (v === 'remark') {
        this.$set(this.otherText, kes, v1.replace(/[;:]/gim, ''))
      }
    },
    setRadioIds: function(id) {
      if (this.radioIds.indexOf(id) !== -1) {
        this.radioIds.splice(this.radioIds.indexOf(id), 1)
      } else {
        this.radioIds.push(id)
      }
    },
	
	resetRadioIds: function(answerTag) {
	  // eg:
	  // answerTag ----- val5c7f0d6a7e254b76b98dac926bb39bdc:BJ-A04:
	  // radio id item ------ 5c7f0d6a7e254b76b98dac926bb39bdc:BJ-A06
	  var tmpRadioID = ''
	  this.radioIds.forEach(function(item) {
	    // 同一题：answerTag.indexOf(item.split(':')[0]) !==-1
	    // 选了不是本二级Radio的选项
	    if (
	      answerTag.indexOf(item.split(':')[0]) !== -1 &&
	      answerTag.indexOf(item) === -1
	    ) {
	      tmpRadioID = item
	    }
	  })	
	  if (tmpRadioID) {
	    this.radioIds.splice(this.radioIds.indexOf(tmpRadioID), 1)
	  }
	},
    clearRadioRemark: function(v) {
      this.resetRadioIds(v)
      var classN = '.' + v.split(':')[0] + ' .radio input'
      var elem = document.querySelectorAll(classN)
      var obj = this.otherText
      for (var i = 0; i < elem.length; i++) {
        var index = ''
        if (elem[i].dataset) {
          index = elem[i].dataset.index
        } else {
          // ie data-index获取自定义属性
          index = elem[i].getAttribute('data-index')
        }
        if (obj[index]) {
          obj[index] = ''
        }
      }
      this.otherText = obj
    },
	
    clickShow: function(num) {
      if (this.titleNum.indexOf(num) !== -1) {
        var add = this.titleNum.indexOf(num)
        this.titleNum.splice(add, 1)
      } else {
        this.titleNum.push(num)
      }
    },
	
	// 若二级没有选择，设置该一级答案状态为uncheck
	// 误删，此次因后台API 不支持二级父题号回显，
	// 答案拼接字符串仅支持 [当前题号]：[答案]:;
	// 暂时屏蔽此逻辑
	setFirstLevelCheckbox: function(answerID) {
	  // var isEmpty = true
	  // this.checkList.forEach(function(item) {
	  //   if (item.length > 0) {
	  //     item.forEach(function(subItem) {
	  //       if (subItem.indexOf(answerID) !== -1) {
	  //         isEmpty = false
	  //       }
	  //     })
	  //   }
	  // })
	  // if (isEmpty) {
	  //   this.titleNum.splice(this.titleNum.indexOf(answerID), 1)
	  // }
	},
	
	clearRemark: function(v, isRepel, index, obj) {
	  var event = window.event
	  var target = event.target || event.srcElement
	  if (!target.checked) {
	    obj = this.otherText
	    obj[v] = ''
	    this.otherText = obj
	  }
	  isRepel
	    ? this.repelBox(isRepel, index, obj)
	    : this.checkboxMaxAnswer(obj, index)
	},
	
	repelBox: function(isRepel, index, obj) {
	  // 互斥多选
	  var event = window.event
	  var target = event.target || event.srcElement
	  var checkArr = this.checkList
	  if (isRepel && target.checked) {
	    // 选中互斥选项
	    checkArr[index] = [target.value]
	    this.checkList = checkArr
	  } else if (isRepel && !target.checked) {
	    // 取消互斥选项
	    checkArr[index] = []
	    this.checkList = checkArr
	  }
	  this.checkboxMaxAnswer(obj, index)
	},
	checkboxMaxAnswer: function(obj, index) {
	  // 多选 最多选择几项；
	  var max = obj.MaxAnswers
	  var checkList = this.checkList
	  var listNum = checkList[index].length
	  if (max > 0) {
	    if (listNum > max) {
	      this.$alert('Select up to ' + max + ' options for this question')
	      checkList[index].pop()
	      this.checkList = checkList
	    }
	  }
	},
	
    backQuFest() {
      this.$router.go(-1)
    },
    
    submitQuest: function() {
      var quest = this.quest // 所有问卷
      var checkList = this.checkList // 多选列表
      var answerArr = this.answerArr // 单选列表
      var otherText = this.otherText // 备注信息
      for (var i = 0; i < quest.length; i++) {
        if (quest[i].required && quest[i].answerType === 1) {
          // 必填 单选验证
          if (!answerArr[i]) {
            this.$alert('Please choose question ' + quest[i].QusNum)
            return ''
          } else if (
            answerArr[i] &&
            answerArr[i].indexOf(';') < 0 &&
            !otherText['val' + answerArr[i]]
          ) {
            // 填写 备注
            console.log(this.otherTips,527)
            this.$alert('Please fill in question ' + quest[i].QusNum + '' + this.otherTips[answerArr[i].split(':')[1]])
            return ''
          }
        } else if (quest[i].required && quest[i].answerType === 2) {
          // 多选必填
          var arr = checkList[i]
          if (arr.length <= 0) {
            this.$alert('Please choose question ' + quest[i].QusNum)
            return ''
          } else if (arr.length > 0) {
            // 填写备注
            for (var j = 0; j < arr.length; j++) {
              if (
                arr[j] &&
                arr[j].indexOf(';') < 0 &&
                !otherText['val' + arr[j]]
              ) {
                console.log(this.otherTips,527)
                this.$alert('Please fill in question ' + quest[i].QusNum + '' + this.otherTips[arr[j].split(':')[1]])
                document.getElementsByName(arr[j])[0].focus()
                return ''
              }
            }
            if (quest[i].MinAnswers > 0 && arr.length < quest[i].MinAnswers) {
              this.$alert(
                '第' +
                  (i + 1) +
                  '个调问最少选择 ' +
                  quest[i].MinAnswers +
                  '个选项'
              )
              return ''
            }
          }
        } else if (quest[i].required && quest[i].answerType === 0) {
          // 填空
          var key =
            'val' +
            quest[i].QusID +
            ':' +
            quest[i].answerOption[0].TssTagID +
            ':'
          if (!this.otherText[key]) {
            this.$alert('Please choose question ' + quest[i].QusNum)
            return ''
          }
        } else if (!quest[i].required && quest[i].answerType === 2) {
          // 多选非必填
          let arr = checkList[i]
          if (arr.length > 0) {
            for (let j = 0; j < arr.length; j++) {
              if (
                arr[j] &&
                arr[j].indexOf(';') < 0 &&
                !otherText['val' + arr[j]]
              ) {
                // 填写备注
                this.$alert('Please fill in question ' + quest[i].QusNum + '' + this.otherTips[arr[j].split(':')[1]])
                document.getElementsByName(arr[j])[0].focus()
                return ''
              }
            }
            if (quest[i].MinAnswers > 0 && arr.length < quest[i].MinAnswers) {
              this.$alert(
                '第' +
                  (i + 1) +
                  '个调问最少选择 ' +
                  quest[i].MinAnswers +
                  '个选项'
              )
              return ''
            }
          }
        } else if (!quest[i].required && quest[i].answerType === 1) {
          // 单选非必填
          if (
            answerArr[i] &&
            answerArr[i].indexOf(';') < 0 &&
            !otherText['val' + answerArr[i]]
          ) {
            // 填写 备注
            this.$alert('Please fill in question ' + quest[i].QusNum + '' + this.otherTips[answerArr[i].split(':')[1]])
            document.getElementsByName(answerArr[i])[0].focus()
            return ''
          }
        }
      }
    
      // 拼接答案
    
      // var list = []
      //  var ansArr = []
      for (let i = 0; i < checkList.length; i++) {
        // 拼接多选备注
        let arr = checkList[i] // 第 i 道问卷 所有选项
    
        if (!arr) {
          continue
        }
    
        for (let j = 0; j < arr.length; j++) {
          if (arr[j] && arr[j].indexOf(';') < 0) {
            // 备注
    
            checkList[i][j] += otherText['val' + arr[j]] + ';'
          }
        }
      }
    
      for (let i = 0; i < answerArr.length; i++) {
        // 拼接 单选 备注
        if (answerArr[i] && answerArr[i].indexOf(';') < 0) {
          answerArr[i] += otherText['val' + answerArr[i]] + ';'
        }
      }
      var ans = checkList.join('') + answerArr.join('')
      ans = ans
        .replace(/undefined/gim, '')
        .replace(/,/gim, '')
        .replace(/null/gim, '')
    
      let params = {
        ExhID: this.ExhID,
        EntryPsjId: sessionStorage.getItem('PsjID'),
        AnsInfo: ans
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    
      if (sessionStorage.getItem('PsnID')) {
        api.updateAns(params).then(res => {
          if (res.data.status === 'OK') {
            this.$router.push({
              path: 'confirmation',
              query: { ExhID: this.ExhID }
            })
          } else {
            this.loading = false
            this.$alert(res.data.ErrorMsg, '错误信息', {
              confirmButtonText: '确定',
              closeOnClickModal: true,
              type: 'error'
            })
          }
        })
      } else {
        params = {
          exhid: this.ExhID,
          Mobile: sessionStorage.getItem('PsnMobile'),
          WapToken: sessionStorage.getItem('token'),
          QusID: 1,
          questEnd: true,
          Ans: ans
        }
        api.saveAns(params).then(res => {
          if (res.data.status === 'OK') {
            sessionStorage.setItem('PsjID', res.data.PsjID)
            if (sessionStorage.getItem('IsRegistActivity') && sessionStorage.getItem('IsRegistActivity') === 'true') { // 如果有会议跳转到选择会议页面
              this.$router.push({
                path: 'meeting',
                query: { ExhID: this.ExhID }
              })
            } else {
              this.$router.push({
                path: 'confirmation',
                query: { ExhID: this.ExhID }
              })
            }
          } else {
            this.loading = false
            this.$alert(res.data.ErrorMsg, '错误信息', {
              confirmButtonText: '确定',
              closeOnClickModal: true,
              type: 'error'
            })
          }
        })
      }
    },
    cacheAnswer: function() {
      // 缓存问卷答案
      sessionStorage.setItem('checkList', JSON.stringify(this.checkList)) // 缓存checkList
      sessionStorage.setItem('otherText', JSON.stringify(this.otherText)) // 缓存otherText
      sessionStorage.setItem('answerArr', JSON.stringify(this.answerArr)) // 单选
    },
    renderAnswer: function(res) {
      var ansA = res.data.AnsInfo.split(';')

      var quest = this.quest

      var checkList = []
      var otherText = {}
      var answerArr = []
      for (let i = 0; i < quest.length; i++) {
        // 遍历所有调问
        var obj = quest[i] // 第i道题调问题
        for (let j = 0; j < ansA.length; j++) {
          // 遍历所有 调问答案
          var ansO = ansA[j].split(':') // 答案

          if (obj.QusID === ansO[0] && obj.answerType === 1) {
            // 单选i 题 有答案[通过题id]
            let anStr = ''
            if (ansO.length > 2) {
              anStr = ansO[0] + ':' + ansO[1] + ':'
              otherText['val' + anStr] = ansO[2]
            } else {
              anStr = ansA[j] + ':;'
            }
            answerArr[i] = anStr

            break
          } else if (obj.QusID === ansO[0] && obj.answerType === 2) {
            // 多选i 题 有答案[通过题id]
            let anStr = ''
            if (ansO.length > 2) {
              anStr = ansO[0] + ':' + ansO[1] + ':'
              otherText['val' + anStr] = ansO[2]
            } else {
              anStr = ansA[j] + ':;'
            }
            if (!checkList[i]) {
              checkList[i] = []
            }

            checkList[i].push(anStr)
          }
        }
      }
      this.checkList = checkList
      this.answerArr = answerArr
      this.otherText = otherText
      var ansArr = ansA
      for (let k = 0; k < quest.length; k++) {
        if (quest[k].answerOption.length > 0 && quest[k].answerOption[0].answersOption.length > 0) {
          for (let p = 0; p < quest[k].answerOption.length; p++) {
            if (quest[k].answerOption[p].answersOption.length > 0) {
              this.checkAns(quest[k].answerOption[p], ansArr)
            }
          }
        }
      }
    },
    checkAns: function(_arr, valArry) {
      for (let k = 0; k < _arr.answersOption.length; k++) {
         var tempOjb = _arr.answersOption[k]
          for (let p = 0; p < valArry.length; p++) {
            if (tempOjb.TssTagID == valArry[p].split(':')[1]) {
              if (this.titleNum.indexOf(_arr.TssTagID) < 0) {
                this.clickShow(_arr.TssTagID)
              }
            }
          }
        }
    },
    remarkInput(index) {
      var obj = this.otherText
      var str = obj['val' + index]
      if (str) {
        str = str.replace(/(^\s*)|(\s*$)/g, '')
        obj['val' + index] = str
        this.otherText = obj
      }
      this.cacheAnswer()
    },

    backQuFest: function() {
      this.$router.push('basicInfo')
    },

    load () {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getQuestions({ ExhID: this.ExhID }).then(res => {
        loading.close()
        if (res.data.status === 'OK') {
          var qArr = res.data.questionnaire
          this.quest = qArr
          var repelArr = []
          for (var i = 0; i < qArr.length; i++) {
            repelArr.push([])
            var obj1 = qArr[i]
            var arr = qArr[i].answerOption
            for (var j = 0; j < arr.length; j++) {
              // 提取输入项提示
              if (arr[j].ansLeveInputText) {
                this.otherTips[arr[j].TssTagID] = arr[j].AnsInputTipText || ' Others, please specify'
              }
              var arrJ = arr[j].answersOption
              if (arrJ.length > 0) {
                // 二级调问 取互斥选项
                for (var z = 0; z < arrJ.length; z++) {
                  // 提取输入项提示
                  if (arrJ[z].ansLeveInputText) {
                    this.otherTips[arrJ[z].TssTagID] = arrJ[z].AnsInputTipText || ' Others, please specify'
                  }
                  var obj = arrJ[z]
                  if (obj.AnsRepelOthers) {
                    // 此选项具有互斥属性
                    var str = obj1.QusID + ':' + obj.TssTagID + ':;'
                    repelArr[i].push(str)
                  }
                }
              } else {
                // 一级调问 取互斥选项
                obj = arr[j]
                if (obj.AnsRepelOthers) {
                  // 此选项具有互斥属性
                  str = obj1.QusID + ':' + obj.TssTagID + ':;'
                  repelArr[i].push(str)
                }
              }
            }
          }
          this.repelArr = repelArr
          for (let i = 0; i < qArr.length; i++) {
            this.checkList.push([])
          }
          if (this.PsjID) {
            this.getPersonAns()
          }
        }
      })
    },
    getPersonAns: function() {
      var param = {
        ExhID: this.ExhID,
        PsnID: sessionStorage.getItem('PsnID')
      }
      api.getUserAnswers(param).then(res => {
        if (res.data.status === 'OK' && res.data.AnsInfo) {
          this.renderAnswer(res)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.proTips{
  padding: 20px 80px 0px;
  font-size: 12px;
}
.box-card .questT{
  padding: 18px 0;
}
.question_box {
  background: #fff;
  box-sizing: border-box;
}
.quest-box{
  width: 60%;
  margin:5px auto;
  max-width: 700px;
}
.question_box h3 {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.question_box .questions {
  text-align: left;
}
.questTitle {
  display: flex;
  padding: 18px 20px;
}
.questTitle b {
  line-height: 18px;
  position: relative;
  top: 3px;
}
.anItembox {
  padding: 10px 0 10px 10px;
}
.answerBox {
  padding: 0 30px;
}
.quest {
  color: #303133;
  padding: 18px 20px;
}
.quest .requiredStar {
  color: red;
}
.childsLevel2 {
  padding: 7px 20px 7px 40px;
  color: #606266;
  font-size: 14px;
}
.childsLevel3 {
  padding: 4px 0;
}
.otherItem {
  display: flex;
  align-items: center;
}
.otherInp .el-input__inner {
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
}
.btn-box {
  // background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 66px 0;
  width: 60%;
  margin: 0 auto;
}
.btn-box .question_btn {
  display: inline-block;
  width: 40%;
}
.btn-box .question_btn{
  width: 50%;
  text-align: center;
}
.btn-box .question_btn button{
  display: inline-block;
  width: 60%;
}
.el-checkbox.is-bordered,
.el-radio.is-bordered {
  border: 0;
}
// .answer-container--firstLevel {
//   display: flex;
//   flex-wrap: wrap;
// }
.answer-firstLevel {
  // width: 47%;
}
.answer-item {
  display: flex;
}
.answer-item .el-input {
  width: 42%;
}
.el-radio-group{
  display: block;
}
.h3.checkbox-level-name {
  text-align: left;
  font-size: 12px;
  cursor: pointer;
  padding: 9px 0 9px 25px;
  .el-checkbox__label {
    padding-left: 6px;
  }
}

.h3.radio-level-name {
  text-align: left;
  font-size: 12px;
  cursor: pointer;
  padding: 9px 0 9px 25px;
}

.second-level-container {
  padding-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Questionnaire.vue